<script>
export default {
  props: ["height", "duration", "start"],

  data: function () {
    return {};
  },
  methods: {
    left: function (start) {
      return start * 5;
    },
    width: function (duration) {
      return duration * 5;
    },
  },
  computed: {
    periodStyle() {
      return {
        
        height: this.height + "%",
        left: this.left(this.start) + "%",
        width: this.width(this.duration) + "%",
      };
    },
  },
};


</script>

<template>
  <div class="periodbar-container">
    <div class="periodbar">
      <div class="periodbar_container" :style="periodStyle"></div>
    </div>
  </div>
</template>
